"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperMessage = exports.Error = exports.EmptyDiv = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var WrapperMessage = _styledComponents.default.label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  font-family: 'Gentleman', Arial, sans-serif;\n  justify-content: center;\n  align-items: center;\n  font-weight: 600;\n  flex-direction: column;\n  height: 40px;\n  color: #ff00ff;\n  ", "\n"])), function (_ref) {
  var $bsStyle = _ref.$bsStyle;
  return $bsStyle || '';
});
exports.WrapperMessage = WrapperMessage;
var EmptyDiv = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 40px;\n  ", "\n"])), function (_ref2) {
  var $bsStyle = _ref2.$bsStyle;
  return $bsStyle || '';
});
exports.EmptyDiv = EmptyDiv;
var Error = _styledComponents.default.label(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  color: #ff00ff;\n  ", "\n"])), function (_ref3) {
  var $bsStyle = _ref3.$bsStyle;
  return $bsStyle || '';
});
exports.Error = Error;